module.exports = __webpack_public_path__ + "static/media/linhwithrobots3.10902ec4.png";